import { S as Swiper, N as Navigation } from './navigation-DhlNkuwK.js';
import { M as Mousewheel } from './mousewheel-BtjAzDjB.js';

class LifestyleSlider extends HTMLElement {
  connectedCallback() {
    this.navigation = this.querySelector('.swiper-button-prev, .swiper-button-next');
    let hasMousewheel = true;
    let hasAutoHeight = false;
    let sliderNavigation = '';
    if (this.navigation) {
      hasMousewheel = false;
      sliderNavigation = {
        nextEl: '.swiper-button-next--lifestyle',
        prevEl: '.swiper-button-prev--lifestyle',
      };
    }
    const slidesSpacing = this.dataset.slidesSpacing;

    if (slidesSpacing === '12') {
      this.slidesPerViewMobile = 1.1;
      this.slidesPerViewDesktop = 1.75;
      this.slidesPerViewXL = 2.5;
      this.slidesPerView2XL = 3.25;
    } else {
      this.slidesPerViewMobile = '1';
      this.slidesPerViewDesktop = 'auto';
      this.slidesPerViewXL = 'auto';
      this.slidesPerView2XL = 'auto';
      hasAutoHeight = true;
    }
    this.initSwiper(
      slidesSpacing,
      this.slidesPerViewMobile,
      this.slidesPerViewDesktop,
      this.slidesPerViewXL,
      this.slidesPerView2XL,
      sliderNavigation,
      hasMousewheel,
      hasAutoHeight
    );
  }

  initSwiper(
    slidesSpacing,
    slidesPerViewMobile,
    slidesPerViewDesktop,
    slidesPerViewXL,
    slidesPerView2XL,
    sliderNavigation,
    hasMousewheel,
    hasAutoHeight
  ) {
    new Swiper(this.querySelector('.swiper--lifestyle'), {
      modules: [Navigation, Mousewheel],
      mousewheel: hasMousewheel,
      autoHeight: hasAutoHeight,
      slidesPerView: slidesPerViewMobile,
      centeredSlides: false,
      breakpoints: {
        768: {
          slidesPerView: slidesPerViewDesktop,
        },
        1280: {
          slidesPerView: slidesPerViewXL,
        },
        1536: {
          slidesPerView: slidesPerView2XL,
        },
      },
      spaceBetween: slidesSpacing,
      navigation: sliderNavigation,
    });
  }
}

customElements.define('lifestyle-slider', LifestyleSlider);
